import { useTranslator } from '@gandi/translate';
import { pathjoin } from '@gandi/utils';
export function useStepList({
  steps,
  sharingId,
  adminURL
}) {
  const {
    __
  } = useTranslator();
  const availableSteps = {
    'credit-card': {
      iconName: 'credit-card',
      title: __('Save a card and facilitate your next purchases.'),
      content: __('Your credit card details will be safely stored at our payment gateway and you can delete or modify them at any time.'),
      url: pathjoin(adminURL, 'billing', sharingId, 'payment-methods', 'add')
    },
    certificates: {
      iconName: 'certificate',
      title: __('Configure your SSL certificates'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'certificate', sharingId)
    },
    iaas: {
      iconName: 'cloud',
      title: __('Configure your Cloud infrastructure'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'cloud', sharingId)
    },
    domains: {
      iconName: 'domain',
      title: __('Configure your domains'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'domain', sharingId)
    },
    mailboxv2: {
      iconName: 'mailboxv2',
      title: __('Configure your mailboxes'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'domain', sharingId)
    },
    'mailbox-standalone': {
      iconName: 'mailbox-standalone',
      title: __('Configure your mailboxes'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'mail', sharingId)
    },
    paas: {
      iconName: 'paas',
      title: __('Configure your Web Hostings'),
      content: __('Start the configuration of your products now!'),
      url: pathjoin(adminURL, 'simplehosting', sharingId)
    }
  };
  return steps.map(step => availableSteps[step]).filter(Boolean);
}